import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

type SortDirection = 'ASC' | 'DESC';
interface SortState {
  category: string;
  direction: SortDirection;
}

@Component({
  selector: 'app-codex-quarter-view',
  templateUrl: './codex-quarter-view.component.html',
  styleUrls: ['./codex-quarter-view.component.scss']
})
export class CodexQuarterViewComponent implements OnInit {

  @Input() currentQuarter!: any;
  @Input() quarterList!: any[];
  @Input() teamNameToDisplay!: string;

  @Output() emitQuarterChange = new EventEmitter<any>();
  @Output() emitSortingChange = new EventEmitter<any>();
  @Output() emitTeamRouting = new EventEmitter<any>();

  activeSort: SortState | null = null;

  activeMenuCategory: any;
  activeQuarterUuid: string = '';

  constructor() { }

  ngOnInit(): void {
    this.activeQuarterUuid = this.currentQuarter.uuid;
  }

  changeQuarter(index: number) {
    this.emitQuarterChange.emit(index);
  }

  openSortMenu(category: string) {
    if (this.activeMenuCategory === category) {
      this.activeMenuCategory = null;
    } else {
      this.activeMenuCategory = category;
    }
  }

  toggleSort(category: string, direction: SortDirection) {
    if (this.activeSort && this.activeSort.category === category && this.activeSort.direction === direction) {
      this.activeSort = null;
    } else {
      this.activeSort = { category, direction };
    }
    this.emitSortingChange.emit(this.activeSort ? this.activeSort?.direction : null);
  }

  hasActiveSort(category: string): boolean {
    return (this.activeSort?.category === category);
  }

  isChecked(category: string, direction: SortDirection): boolean {
    return (this.activeSort?.category === category && this.activeSort?.direction === direction);
  }

  goBackToTeam() {
    this.emitTeamRouting.emit();
  }

}
